export default __webpack_public_path__ + "static/media/warning.2148d993.svg";